import { Component, OnInit } from '@angular/core';
import { LoaderService } from 'src/app/services/loader.service';
import * as _ from 'lodash';
@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {

  constructor(private loaderSvc: LoaderService) { }

  isLoaded = false;
  loaderType = '';
  currentLoaderText = '';
  currentTextIndex: number = 0;
  loaderIntervalRef: any;
  ngOnInit() {
    this.loaderSvc.loader.subscribe((data: any) => {
      this.currentLoaderText = undefined;
      this.currentTextIndex = 0;
      this.isLoaded = false;
      setTimeout(() => {
        this.loaderType = !_.isUndefined(data.type) ? data.type : '';
        this.isLoaded = !_.isUndefined(data.isDisplay) ? data.isDisplay : true;
        if(!_.isUndefined(data.loadingTexts)){
          this.currentLoaderText = data.loadingTexts[0];
          this.loaderIntervalRef = setInterval( () => {this.changeText(data.loadingTexts)}, 3000);
        } else if (!_.isUndefined(this.loaderIntervalRef)) {
          clearInterval(this.loaderIntervalRef);
        }
      }, 200);
    });
  }

  changeText(textsArr): void {
    this.currentTextIndex = (this.currentTextIndex + 1) % textsArr.length;
    this.currentLoaderText = textsArr[this.currentTextIndex];
  }
}
